import { h } from 'preact';
import { Link, getPageUrl } from 'components/core/link/link';
import { smoothScrollTo } from 'utils/smoothScroll';
import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import Button from 'components/shared/button/button';
import * as BaseComp from 'components/shared/footer/footer.js';
import route from 'components/core/link/route';
import s from 'components/shared/footer/footer.sss';
import Store from 'store/store';
import * as actions from 'store/actions';

export default class Footer extends BaseComp.default {
	renderStudioLogo(studioLogo) {
		const {
			src       = '',
			alt       = '',
			ariaLabel = '',
			href      = '',
			pageId    = '',
			title     = ''
		} = studioLogo;

		return (
			<Link
				class={s.studioLogo}
				renderCustomChild
				href={href}
				pageId={pageId}
				title={title}
				ariaLabel={ariaLabel}
			>
				<img class={s.image} src={src} alt={alt} />
			</Link>
		);
	}

	renderSponsors(data) {
		const sponsors = sortObjectByOrder(data);

		return (
			<ul class={s.sponsors}>
				{sponsors.map(logo => {
					const {
						src       = '',
						alt       = '',
						ariaLabel = '',
						href      = '',
						pageId    = '',
						title     = '',
						id        = ''
					} = logo;

					return (
						<li class={joinClasses(s.sponsor, s[id])}>
							<Link
								class={joinClasses(s.logo, s[id])}
								renderCustomChild
								href={href}
								pageId={pageId}
								title={title}
								ariaLabel={ariaLabel}
								target={href ? '_blank' : '_self'}
								rel='noopener'
								extraOnClick={() => {Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'partner-click', 'navigation', id);}}
							>
								<img class={s.image} src={src} alt={alt} />
							</Link>
						</li>
					);
				})}
			</ul>
		);
	}

	renderLinks(data) {
		const links = sortObjectByOrder(data);

		const firstGroup = links.slice(0, 4);
		const secondGroup = links.slice(4);
		return (
			<ul class={s.links}>
				{[firstGroup, secondGroup].map(group => {
					return <li class={s.list}>
						{group.map(link => {
							const data = { ...link, type: 'footer' };
							let extraOnClick = () => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'footer-click', 'navigation', data.label);
							if (data.label === 'Screen our content') {
								const activePage = accessNested(this.props, 'activePage.id');
								if (activePage === 'about') {
									data.pageId = null;
									data.href = 'javascript:void(0)'
									extraOnClick = () => {
										Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'footer-click', 'navigation', data.label);
										smoothScrollTo('root', document.getElementById('screen'), 600, { force: false });
									}
								} else {
									extraOnClick = () => {
										Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'footer-click', 'navigation', data.label);
										goToScreen('about');
									}
								}
							}

							return <Button extraClass={joinClasses(s.item)} extraOnClick={extraOnClick} data={data} client={this.props.client} />
						})}
					</li>;
				})}
			</ul>
		);

	}

	renderSocials(data) {
		const socials = sortObjectByOrder(data);

		return (
			<ul class={s.socials}>
				{socials.map(item => {
					const {
						icon      = '',
						href      = '',
						label     = '',
						alt       = '',
						title     = '',
						ariaLabel = '',
						type      = ''
					} = item;

					return <li class={s.social}>
						<Link
							href={href}
							title={title}
							ariaLabel={ariaLabel}
							target='_blank'
							rel='noopener'
							extraOnClick={() => {Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'follow', 'social', type)}}
						>
							<img class={s.icon} src={icon} alt={alt} />
						</Link>
					</li>;
				})}
			</ul>
		);
	}

	renderCopyright(copyrights) {
		return <div class={s.copyrights}>
			<p class={s.copyright}>{copyrights.nationalTheatre}</p>
			<Link href="https://www.powster.com" target="_blank" class={joinClasses(s.copyright, s.powster)}>{copyrights.powster}</Link>
		</div>;
	}

	render({ appData }) {
		const {
			studioLogo  = {},
			sponsors    = {},
			links       = {},
			copyrights  = {},
			socials     = {}
		} = appData.footer;

		return (
			<footer class={s.wrapper}>
				<div class={s.container}>
					<div class={s.logos}>
						{this.renderStudioLogo(studioLogo)}
						{this.renderSponsors(sponsors)}
					</div>
					<div>
						{this.renderLinks(links)}
						{this.renderSocials(socials)}
					</div>
					{this.renderCopyright(copyrights)}
				</div>
			</footer>
		);
	}
}

function goToScreen(pageId, queryString, noMergeQS, hash) {
	let href = getPageUrl(pageId, queryString, noMergeQS, hash);
	if (!href) return;
	let page = accessNested(Store.get(), ['appData', 'pages', pageId]);
	history.replaceState({ pageId }, '', href);
	Store.emit(actions.SET_ACTIVE_PAGE, page, 'screen');
}
